export default __webpack_public_path__ + "36b7d862c6efacb43409a962f58b808c.png";